import { useEffect, useState } from "react";
import { getMenuByID } from "../api/menu.api";

/** Menu-specific sauce choices are stored on menus, not on categories. */
export function useOrderSauce(menuId: number, previousRemark: string) {
  const [sauces, setSauces] = useState<string[] | null>(null);
  const [loaded, setLoaded] = useState(false);
  const [sauce, setSauce] = useState("");
  const [previousNote, setPreviousNote] = useState("");

  useEffect(() => {
    let active = true;
    setLoaded(false);
    if (!menuId) return;
    getMenuByID(menuId).then((menu) => {
      if (active) {
        setSauces(Array.isArray(menu.sauces) ? menu.sauces : null);
        setLoaded(true);
      }
    }).catch(() => { if (active) setLoaded(false); });
    return () => { active = false; };
  }, [menuId]);

  useEffect(() => {
    if (!previousRemark || previousRemark === "-") return;
    const match = previousRemark.match(/^Sauce:\s*([^—]+?)(?:\s*—\s*(.*))?$/);
    if (match) {
      setSauce(match[1].trim());
      setPreviousNote(match[2]?.trim() ?? "");
    } else setPreviousNote(previousRemark);
  }, [previousRemark]);

  const hasSauces = !!sauces?.length;
  const valid = loaded && (!hasSauces || (!!sauce && sauces!.includes(sauce)));
  const remark = (note: string) => hasSauces
    ? `Sauce: ${sauce}${note.trim() ? ` — ${note.trim()}` : ""}`
    : (note.trim() || "-");

  return { sauces, sauce, setSauce, hasSauces, valid, remark, previousNote };
}

export function OrderSaucePicker({ sauces, sauce, onChange }: {
  sauces: string[] | null;
  sauce: string;
  onChange: (value: string) => void;
}) {
  if (!sauces?.length) return null;
  return <section className="mb-6">
    <span className="block font-display font-bold text-sm text-ink-1000 mb-2">Sauce <span className="text-rose-500">*</span></span>
    <div className="grid grid-cols-3 gap-2">
      {sauces.map(s => <button key={s} type="button" onClick={() => onChange(s)}
        className={`h-[60px] rounded-2xl font-display font-bold text-sm border-2 transition ${sauce === s ? "bg-ink-1000 text-ink-0 border-ink-1000" : "bg-ink-50 text-ink-700 border-transparent hover:border-ink-200"}`}>{s}</button>)}
    </div>
    <p className="text-[11px] text-ink-500 mt-1.5">Pick one — sauce is required.</p>
  </section>;
}
